<script>
    import saveSvgAsPng from "save-svg-as-png";
    import svgAsPngUri from "save-svg-as-png";
    import chroma from "chroma-js";

    export let evils = "npm"
    
    let svgDownload;
    
    export let w=1224;
    export let h=1548;
    export let dw = 400;
    export let dh = 600;
    export let dx
    export let dy 
    export let qrx
    export let qry
    export let namex  = 100
    export let namey = 100
    export let buttonName
    export let fileName
    export let display = false;
    export let baseColor;
    export let fname;
    export let lname;
    export let backgroundColor = "#FFFFFF";
    export let showbg = true

    export let fontsize = 14;
    


    function svgDataURL(svgDownload) {
        var svgAsXML = new XMLSerializer().serializeToString(svgDownload);
        return "data:image/svg+xml," + encodeURIComponent(svgAsXML);
    }

    function download() {
        var dl = document.createElement("a");
        document.body.appendChild(dl); // This line makes it work in Firefox.
        dl.setAttribute("href", svgDataURL(svgDownload));
        dl.setAttribute("download", "demon.svg");
        dl.click();
    }

	function saveSvg(){
        
		saveSvgAsPng.saveSvgAsPng(svgDownload, fileName+"-"+"("+buttonName+")"+".png");
	
	}
    function getDataURI(){

       console.log(svgAsPngUri.svgAsDataUri(svgDownload))
    }
    

</script>

<div class="downloadButton">
	<button on:click={saveSvg} style="color:{chroma(baseColor).darken(2)};" class="flex space-x-2 items-center">          
        <span>            
            <svg viewBox="0 0 20 20" height="20" width="20" xmlns="http://www.w3.org/2000/svg">,<g transform="matrix(0.8333333333333334,0,0,0.8333333333333334,0,0)"><path d="M24,10.663A5.817,5.817,0,0,0,22.228,6.5a5.711,5.711,0,0,0-3.447-1.585.249.249,0,0,1-.191-.12,7.684,7.684,0,0,0-14.1,2.294.251.251,0,0,1-.227.2A4.59,4.59,0,0,0,0,11.859a4.324,4.324,0,0,0,1.236,3.21,5.529,5.529,0,0,0,3.605,1.377,1,1,0,0,0,.985-1.015,1.023,1.023,0,0,0-1.015-.985,3.3,3.3,0,0,1-2.172-.8A2.374,2.374,0,0,1,2,11.859a2.576,2.576,0,0,1,.954-2.007,2.6,2.6,0,0,1,2.167-.527,1,1,0,0,0,1.2-.919,5.686,5.686,0,0,1,10.82-2.088.959.959,0,0,0,.941.57A3.687,3.687,0,0,1,20.84,7.937,3.752,3.752,0,0,1,22,10.663a3.835,3.835,0,0,1-3.438,3.791,1,1,0,0,0,.132,1.992.961.961,0,0,0,.131-.009A5.807,5.807,0,0,0,24,10.663Z" fill="{chroma(baseColor).darken(2)}" stroke="none" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M15.5,17.446H13.75a.25.25,0,0,1-.25-.25V9.946a1.5,1.5,0,1,0-3,0V17.2a.25.25,0,0,1-.25.25H8.5a1,1,0,0,0-.707,1.707l3.5,3.5a1,1,0,0,0,1.414,0l3.5-3.5a1,1,0,0,0-.707-1.707Z" fill="{chroma(baseColor).darken(2)}" stroke="none" stroke-linecap="round" stroke-linejoin="round"></path></g>
            </svg>
        </span>
        <span>{buttonName}</span>
    
    </button> 
</div>



<svg
    viewBox="0 0 {w} {h}"
    width="{w}px"
    height="{h}px"        
    bind:this={svgDownload}
    style="{!display ? 'display:none;': ''}"
    overflow="hidden"
    
>
{#if showbg}
<rect width="100%" height="100%" x=0 y=0 fill="{backgroundColor}"/>
{/if}
    <g transform="translate({dx} {dy})" width="{dw}px" height="{dh}px">
        <slot name="demon"/>
    </g>

    <g transform="translate({qrx} {qry})" >
        <slot name="qr"/>
    </g> 
    <g transform="translate({namex} {namey})" >
        <text font-size="{fontsize}px" letter-spacing="4" font-weight="bold"  style="text-transform:uppercase;font-family:sans-serif;"  fill="#000" text-anchor="start" >{fname+" "+lname}</text>
     
        <g transform="translate(0 {fontsize*1.2})">
            <text font-size="{fontsize*.7}px" letter-spacing="0" font-weight="regular"  style="font-family:sans-serif;"  fill="#000" text-anchor="start" >Guardian Demons</text>

        </g>
      
        <g transform="translate(0 {fontsize*2.2})">
            <text font-size="{fontsize*.5}px" letter-spacing="0" font-weight="regular"  style="font-family:sans-serif;"  fill="#000" text-anchor="start" >©2022 John Dilworth, Knotwork Industries, LLC</text>            
        </g>
    </g> 
</svg>


<style>
    .downloadButton {        
        background: none;
        
    }

    @media only print{
        .downloadButton{
            display: none;
        }
    }
</style>
